import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, ViewChild, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'
import { Materials_material_statuses_dd_singleComponent } from './Materials.material_statuses_dd_single.component'
import { Materials_material_groups_dd_singleComponent } from './Materials.material_groups_dd_single.component'
import { Materials_allocation_strategy_dd_singleComponent } from './Materials.allocation_strategy_dd_single.component'


interface IFootPrintPortalManager_materials_by_base_packaging_gridComponentEntity {
MaterialId?: number, PackagingId?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, UpcCode?: string, UseAsShippingContainer?: boolean, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Material?: { Id?: number, AllocationStrategyId?: number, ControllerTypeId?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, Description?: string, GlobalMaterialId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, Name?: string, ProjectId?: number, ShelfLifeSpan?: number, StatusId?: number, Project?: { Id?: number, LookupCode?: string, Name?: string, Owner?: { Id?: number, LookupCode?: string, Name?: string } }, ControllerType?: { Id?: number, Name?: string }, GlobalMaterial?: { Id?: number, Name?: string }, MaterialGroup?: { Name?: string }, Status?: { Id?: number, Name?: string }, AllocationStrategy?: { Name?: string } }, Packaging?: { Id?: number, ShortName?: string }, DimensionsUom?: { Id?: number, Short_name?: string }, VolumeUom?: { Id?: number, Short_name?: string }, WeightUom?: { Id?: number, Short_name?: string }}

interface IFootPrintPortalManager_materials_by_base_packaging_gridComponentInParams {
  projectId?: number, ownerId: number, materialIds?: number[]}


class FootPrintPortalManager_materials_by_base_packaging_gridComponentRowModel extends GridRowModel {
  grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent;
  entity: IFootPrintPortalManager_materials_by_base_packaging_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    upc_code_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    material_status_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    length_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    width_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    height_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shipping_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_high_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    pallet_tie_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    material_group_name_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    allocation_strategy_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    lot_controlled_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    serial_controlled_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    serial_controlled_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_weight_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_weight_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_volume_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_volume_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_dimension_display: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    is_fixed_dimension_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    shelf_life_span_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
    description_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    lookupcode: new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      new TextModel(null, null )
,
null
      ),
    upc_code: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['upc_code_edit'] as DatexFormControl, null, false, '')
      ),
    packaging_short_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    material_status_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['material_status_name_edit'] as DatexFormControl, 
        null, null,
        false, 
        '')
      ),
    length: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['length_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    width: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['width_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    height: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['height_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    weight: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['weight_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    shipping_weight: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['shipping_weight_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    volume: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['volume_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    shipping_volume: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['shipping_volume_edit'] as DatexFormControl, null, false, '0.00', '')
      ),
    pallet_high: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['pallet_high_edit'] as DatexFormControl, null, false, '0', '')
      ),
    pallet_tie: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['pallet_tie_edit'] as DatexFormControl, null, false, '0', '')
      ),
    material_group_name: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['material_group_name_edit'] as DatexFormControl, 
        null, null,
        false, 
        '')
      ),
    allocation_strategy: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new SelectBoxModel(
        this.formGroup.controls['allocation_strategy_edit'] as DatexFormControl, 
        null, null,
        false, 
        '')
      ),
    lot_controlled: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['lot_controlled_display'] as DatexFormControl, null, true, '')
,
null
      ),
    serial_controlled: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['serial_controlled_display'] as DatexFormControl, null, true, '')
,
      new CheckBoxModel(this.formGroup.controls['serial_controlled_edit'] as DatexFormControl, null, false, '')
      ),
    is_fixed_weight: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['is_fixed_weight_display'] as DatexFormControl, null, true, '')
,
      new CheckBoxModel(this.formGroup.controls['is_fixed_weight_edit'] as DatexFormControl, null, false, '')
      ),
    is_fixed_volume: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['is_fixed_volume_display'] as DatexFormControl, null, true, '')
,
      new CheckBoxModel(this.formGroup.controls['is_fixed_volume_edit'] as DatexFormControl, null, false, '')
      ),
    is_fixed_dimension: new GridCellModel(
      new CellStyles(null, null),
      new CheckBoxModel(this.formGroup.controls['is_fixed_dimension_display'] as DatexFormControl, null, true, '')
,
      new CheckBoxModel(this.formGroup.controls['is_fixed_dimension_edit'] as DatexFormControl, null, false, '')
      ),
    shelf_life_span: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new NumberBoxModel(this.formGroup.controls['shelf_life_span_edit'] as DatexFormControl, null, false, '0', '')
      ),
    description: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
      new TextBoxModel(this.formGroup.controls['description_edit'] as DatexFormControl, null, false, '')
      ),
    owner: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
    project: new GridCellModel(
      new CellStyles(null, null),
      new TextModel(null, null )
,
null
      ),
  }



  constructor(
    private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
) {
    super();
    
  }

  async $initializeExisting(grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent, entity: IFootPrintPortalManager_materials_by_base_packaging_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.entity = entity;

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent, entity?: IFootPrintPortalManager_materials_by_base_packaging_gridComponentEntity, propertyChangeCallback: (source: GridRowModel, property: string) => void = null) {
    this.$propertyChangeCallback = propertyChangeCallback;

    this.grid = grid;
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.MaterialId,this.entity.PackagingId].join('-');
    this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    const $resultKey = {};
    set($resultKey, 'MaterialId',this.entity.MaterialId);
    set($resultKey, 'PackagingId',this.entity.PackagingId);
    const inParams = {
      $keys:[$resultKey],
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      fullTextSearch:  $grid.fullTextSearch ,
      materialIds:  $grid.inParams.materialIds ,
    };
    const data = await this.datasources.Materials.ds_materials_by_base_packaging_grid.getByKeys(inParams);
    this.entity = data.result[0];
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.utils;
    (this.cells.lookupcode.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.upc_code.displayControl as TextModel).text = $row.entity.UpcCode;
    (this.cells.upc_code.editControl as TextBoxModel).reset($row.entity.UpcCode);
    (this.cells.packaging_short_name.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.material_status_name.displayControl as TextModel).text = $row.entity.Material?.Status?.Name;
    (this.cells.material_status_name.editControl as SelectBoxModel).reset($row.entity.Material.StatusId);
    (this.cells.length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.length.editControl as NumberBoxModel).reset($row.entity.Length);
    (this.cells.width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.width.editControl as NumberBoxModel).reset($row.entity.Width);
    (this.cells.height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.height.editControl as NumberBoxModel).reset($row.entity.Height);
    (this.cells.weight.displayControl as TextModel).text = $row.entity.Weight?.toString();
    (this.cells.weight.editControl as NumberBoxModel).reset($row.entity.Weight);
    (this.cells.shipping_weight.displayControl as TextModel).text = $row.entity.ShippingWeight?.toString();
    (this.cells.shipping_weight.editControl as NumberBoxModel).reset($row.entity.ShippingWeight);
    (this.cells.volume.displayControl as TextModel).text = $row.entity.Volume?.toString();
    (this.cells.volume.editControl as NumberBoxModel).reset($row.entity.Volume);
    (this.cells.shipping_volume.displayControl as TextModel).text = $row.entity.ShippingVolume?.toString();
    (this.cells.shipping_volume.editControl as NumberBoxModel).reset($row.entity.ShippingVolume);
    (this.cells.pallet_high.displayControl as TextModel).text = $row.entity.PalletHigh?.toString();
    (this.cells.pallet_high.editControl as NumberBoxModel).reset($row.entity.PalletHigh);
    (this.cells.pallet_tie.displayControl as TextModel).text = $row.entity.PalletTie?.toString();
    (this.cells.pallet_tie.editControl as NumberBoxModel).reset($row.entity.PalletTie);
    (this.cells.material_group_name.displayControl as TextModel).text = $row.entity.Material?.MaterialGroup?.Name;
    (this.cells.material_group_name.editControl as SelectBoxModel).reset($row.entity.Material.MaterialGroupId);
    (this.cells.allocation_strategy.displayControl as TextModel).text = $row.entity.Material?.AllocationStrategy?.Name;
    (this.cells.allocation_strategy.editControl as SelectBoxModel).reset($row.entity.Material.AllocationStrategyId);
    (this.cells.serial_controlled.displayControl as CheckBoxModel).reset($row.entity.Material.ControllerTypeId == 3 || $row.entity.Material.ControllerTypeId == 4 ? true : false);
    (this.cells.serial_controlled.editControl as CheckBoxModel).reset($row.entity.Material.ControllerTypeId == 3 || $row.entity.Material.ControllerTypeId == 4 ? true : false);
    (this.cells.is_fixed_weight.displayControl as CheckBoxModel).reset($row.entity.Material?.IsFixedWeight);
    (this.cells.is_fixed_weight.editControl as CheckBoxModel).reset($row.entity.Material?.IsFixedWeight);
    (this.cells.is_fixed_volume.displayControl as CheckBoxModel).reset($row.entity.Material?.IsFixedVolume);
    (this.cells.is_fixed_volume.editControl as CheckBoxModel).reset($row.entity.Material?.IsFixedVolume);
    (this.cells.is_fixed_dimension.displayControl as CheckBoxModel).reset($row.entity.Material?.IsFixedLength);
    (this.cells.is_fixed_dimension.editControl as CheckBoxModel).reset($row.entity.Material?.IsFixedLength);
    (this.cells.shelf_life_span.displayControl as TextModel).text = $row.entity.Material?.ShelfLifeSpan?.toString();
    (this.cells.shelf_life_span.editControl as NumberBoxModel).reset($row.entity.Material.ShelfLifeSpan);
    (this.cells.description.displayControl as TextModel).text = $row.entity.Material?.Description;
    (this.cells.description.editControl as TextBoxModel).reset($row.entity.Material?.Description);
    (this.cells.owner.displayControl as TextModel).text = $row.entity.Material?.Project?.Owner?.LookupCode;

    await this.on_row_data_loaded();
  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
      await this.on_save_existing_row();
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'lookupcode' : {
        this.on_lookupcode_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_save_existing_row(event = null) {
    return this.on_save_existing_rowInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_save_existing_rowInternal(
    $row: FootPrintPortalManager_materials_by_base_packaging_gridComponentRowModel,
  $grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  let payload: any = {};
  
  if ($row.cells.is_fixed_weight.editControl.isChanged
      || $row.cells.is_fixed_dimension.editControl.isChanged
      || $row.cells.is_fixed_volume.editControl.isChanged
      || $row.cells.serial_controlled.editControl.isChanged
  ) {
  
      const inventory = (await $datasources.Materials.ds_get_licenseplatecontents_by_materialId_top1.get({
          materialId: $row.entity.MaterialId
      })).result;
      if (!$utils.isDefined(inventory)) {
          payload.IsFixedWeight = $row.cells.is_fixed_weight.editControl.value;
          payload.IsFixedLength = $row.cells.is_fixed_dimension.editControl.value;
          payload.IsFixedVolume = $row.cells.is_fixed_volume.editControl.value;
  
          if ($row.cells.serial_controlled.editControl.isChanged) {
              const currentControllerTypeId = $row.entity.Material.ControllerTypeId;
              var controllerTypeId;
              if (currentControllerTypeId === 1) {
                  controllerTypeId = 3
              }
              if (currentControllerTypeId === 2) {
                  controllerTypeId = 4
              }
              if (currentControllerTypeId === 3) {
                  controllerTypeId = 1
              }
              if (currentControllerTypeId === 4) {
                  controllerTypeId = 2
              }
              payload.ControllerTypeId = controllerTypeId
          }
      }
      else {
          var errorMessage = ''
          errorMessage += 'Material currently contains inventory, cannot change Fixed weight, fixed dimension, fixed volume and or serial controlled options.';
          $shell.Materials.showErrorDetails('Save', 'Error on save.', errorMessage);
          throw errorMessage; // to prevent displayMode 
  
      }
  
  
  }
  // Future code to handle changing lot controlled property. Make sure to handle controller type change while accounting for serial controlled change.
  
  
  if ($row.cells.allocation_strategy.editControl.isChanged) {
      payload.AllocationStrategyId = $row.cells.allocation_strategy.editControl.value;
  }
  if ($row.cells.description.editControl.isChanged) {
      payload.Description = $row.cells.description.editControl.value;
  }
  if ($row.cells.material_group_name.editControl.isChanged) {
      payload.MaterialGroupId = $row.cells.material_group_name.editControl.value;
  }
  if ($row.cells.shelf_life_span.editControl.isChanged) {
      payload.ShelfLifeSpan = $row.cells.shelf_life_span.editControl.value;
  }
  if ($row.cells.material_status_name.editControl.isChanged) {
      payload.StatusId = $row.cells.material_status_name.editControl.value;
  }
  
  
  let payloadpackaging: any = {};
  
  if ($row.cells.length?.editControl.isChanged) {
      payloadpackaging.Length = $row.cells.length?.editControl.value;
  }
  if ($row.cells.width?.editControl.isChanged) {
      payloadpackaging.Width = $row.cells.width?.editControl.value;
  }
  if ($row.cells.height?.editControl.isChanged) {
      payloadpackaging.Height = $row.cells.height?.editControl.value;
  }
  if ($row.cells.weight?.editControl.isChanged) {
      payloadpackaging.Weight = $row.cells.weight?.editControl.value;
  }
  if ($row.cells.shipping_weight?.editControl.isChanged) {
      payloadpackaging.ShippingWeight = $row.cells.shipping_weight?.editControl.value;
  }
  if ($row.cells.volume?.editControl.isChanged) {
      payloadpackaging.Volume = $row.cells.volume?.editControl.value;
  }
  if ($row.cells.shipping_volume?.editControl.isChanged) {
      payloadpackaging.ShippingVolume = $row.cells.shipping_volume?.editControl.value;
  }
  if ($row.cells.pallet_high?.editControl.isChanged) {
      payloadpackaging.PalletHigh = $row.cells.pallet_high?.editControl.value;
  }
  if ($row.cells.pallet_tie?.editControl.isChanged) {
      payloadpackaging.PalletTie = $row.cells.pallet_tie?.editControl.value;
  }
  if ($row.cells.upc_code?.editControl.isChanged) {
      payloadpackaging.UpcCode = $row.cells.upc_code?.editControl.value;
  }
  
  
  try {
  
      await $flows.Utilities.crud_update_flow({ entitySet: 'Materials', id: $row.entity.Material.Id, entity: payload });
  
  
      await $flows.Utilities.crud_update_dual_pk_flow({
          entitySet: 'MaterialsPackagingsLookup',
          entity: payloadpackaging,
          pk1String: 'MaterialId',
          pk1: $row.entity.Material.Id,
          pk2String: 'PackagingId',
          pk2: $row.entity.PackagingId
      });
  
  
      await $row.refresh();
  
  }
  
  catch (error) {
      $shell.Materials.showErrorDetails('Save', 'Error on save.', error);
      throw error; // to prevent displayMode 
  }
  
  
  
  
  
  }
  on_row_data_loaded(event = null) {
    return this.on_row_data_loadedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_row_data_loadedInternal(
    $row: FootPrintPortalManager_materials_by_base_packaging_gridComponentRowModel,
  $grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  var ControllerTypeId = $row.entity.Material?.ControllerTypeId;
  
  
  if (ControllerTypeId === 1){
  $row.cells.lot_controlled.displayControl.value = false;
  $row.cells.serial_controlled.displayControl.value = false;
  
  }
  if (ControllerTypeId === 2){
  $row.cells.lot_controlled.displayControl.value = true;
  $row.cells.serial_controlled.displayControl.value = false;  
  
  }
  if (ControllerTypeId === 3){
  $row.cells.lot_controlled.displayControl.value = false;
  $row.cells.serial_controlled.displayControl.value = true;    
  
  }
  if (ControllerTypeId === 4){
  $row.cells.lot_controlled.displayControl.value = true;
  $row.cells.serial_controlled.displayControl.value = true;  
  
  }
  // Apply custom project string logic
  if ($row.entity.Material?.Project?.LookupCode === $row.entity.Material?.Project?.Name) {
      $row.cells.project.displayControl.text = $row.entity.Material?.Project?.LookupCode
  } else {
      $row.cells.project.displayControl.text = $row.entity.Material?.Project?.LookupCode + ' ' + $row.entity.Material?.Project?.Name
  }
  
  // Apply custom owner string logic
  if ($row.entity.Material?.Project?.Owner?.LookupCode === $row.entity.Material?.Project?.Owner?.Name) {
      $row.cells.owner.displayControl.text = $row.entity.Material?.Project?.Owner?.LookupCode
  } else {
      $row.cells.owner.displayControl.text = $row.entity.Material?.Project?.Owner?.LookupCode + ' ' + $row.entity.Material?.Project?.Owner?.Name
  }
  
         
  }
  on_lookupcode_clicked(event = null) {
    return this.on_lookupcode_clickedInternal(
      this,
  this.grid, this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lookupcode_clickedInternal(
    $row: FootPrintPortalManager_materials_by_base_packaging_gridComponentRowModel,
  $grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent, 
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootPrintPortalManager.opensingle_material_hub({materialId: $row.entity.MaterialId});
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Materials_material_statuses_dd_singleComponent),
    forwardRef(() => Materials_material_groups_dd_singleComponent),
    forwardRef(() => Materials_allocation_strategy_dd_singleComponent),
  ],
  selector: 'FootPrintPortalManager-materials_by_base_packaging_grid',
  templateUrl: './FootPrintPortalManager.materials_by_base_packaging_grid.component.html'
})
export class FootPrintPortalManager_materials_by_base_packaging_gridComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootPrintPortalManager_materials_by_base_packaging_gridComponentEntity[];

  pageSize = 5;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootPrintPortalManager_materials_by_base_packaging_gridComponentInParams = { projectId: null, ownerId: null, materialIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     lookupcode: new GridHeaderModel(new HeaderStyles(null, null), 'Lookup', false, false, null),       upc_code: new GridHeaderModel(new HeaderStyles(null, null), 'Upc', false, false, null),       packaging_short_name: new GridHeaderModel(new HeaderStyles(null, null), 'Base uom', false, false, null),       material_status_name: new GridHeaderModel(new HeaderStyles(null, null), 'Status', false, false, null),       length: new GridHeaderModel(new HeaderStyles(null, null), 'Length', false, false, null),       width: new GridHeaderModel(new HeaderStyles(null, null), 'Width', false, false, null),       height: new GridHeaderModel(new HeaderStyles(null, null), 'Height', false, false, null),       weight: new GridHeaderModel(new HeaderStyles(null, null), 'Weight', false, false, null),       shipping_weight: new GridHeaderModel(new HeaderStyles(null, null), 'Shipping weight', false, false, null),       volume: new GridHeaderModel(new HeaderStyles(null, null), 'Volume', false, false, null),       shipping_volume: new GridHeaderModel(new HeaderStyles(null, null), 'Shipping volume', false, false, null),       pallet_high: new GridHeaderModel(new HeaderStyles(null, null), 'Pallet high', false, false, null),       pallet_tie: new GridHeaderModel(new HeaderStyles(null, null), 'Pallet tie', false, false, null),       material_group_name: new GridHeaderModel(new HeaderStyles(null, null), 'Group', false, false, null),       allocation_strategy: new GridHeaderModel(new HeaderStyles(null, null), 'Allocation strategy', false, false, null),       lot_controlled: new GridHeaderModel(new HeaderStyles(null, null), 'Lot controlled', false, false, null),       serial_controlled: new GridHeaderModel(new HeaderStyles(null, null), 'Serial controlled', false, false, null),       is_fixed_weight: new GridHeaderModel(new HeaderStyles(null, null), 'Fixed weight', false, false, null),       is_fixed_volume: new GridHeaderModel(new HeaderStyles(null, null), 'Fixed volume', false, false, null),       is_fixed_dimension: new GridHeaderModel(new HeaderStyles(null, null), 'Fixed dimension', false, false, null),       shelf_life_span: new GridHeaderModel(new HeaderStyles(null, null), 'Shelf life', false, false, null),       description: new GridHeaderModel(new HeaderStyles(null, null), 'Description', false, false, null),       owner: new GridHeaderModel(new HeaderStyles(null, null), 'Owner', false, false, null),       project: new GridHeaderModel(new HeaderStyles(null, null), 'Project', false, false, null),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootPrintPortalManager_materials_by_base_packaging_gridComponentRowModel[] = [];
  @ViewChild('$gridComponent', { read:  GridComponent}) $gridComponent: GridComponent;

  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };



  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    private shell: FootPrintPortalManager_ShellService,
    private datasources: FootPrintPortalManager_DatasourceService,
    private flows: FootPrintPortalManager_FlowService,
    private reports: FootPrintPortalManager_ReportService,
    private localization: FootPrintPortalManager_LocalizationService,
    private operations: FootPrintPortalManager_OperationService,
    ) {
    this.title = 'Materials';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if(!this.$hasMissingRequiredInParams) {
      this.$init();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.ownerId)) {
        this.$missingRequiredInParams.push('ownerId');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
  }

  async $init() {
    const $grid = this;
    const $utils = this.utils;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  $rowPropertyChangeCallback (source: GridRowModel, property: string): void {
    if (property === 'selected') {
      this.$gridComponent.updateAllSelected();
    }
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      projectId:  $grid.inParams.projectId ,
      ownerId:  $grid.inParams.ownerId ,
      fullTextSearch:  $grid.fullTextSearch ,
      materialIds:  $grid.inParams.materialIds ,
    };
    try {
    const data = await this.datasources.Materials.ds_materials_by_base_packaging_grid.getList(inParams);
      this.entities = data.result;
      this.totalCount = data.totalCount;
      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.utils;
    
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootPrintPortalManager_materials_by_base_packaging_gridComponentRowModel(
          this.utils,
          this.settings,
          this.shell, 
          this.datasources,
          this.flows,
          this.reports,
          this.localization,
          this.operations);
        rowLoadPromises.push( row.$initializeExisting(this, entity, this.$rowPropertyChangeCallback.bind(this)));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }


  
  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootPrintPortalManager_materials_by_base_packaging_gridComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  if (await $operations.FootPrintPortalManager.Disable_Material_Update.isAuthorized()){
      $grid.canEdit = false;
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
